
import { useRef, useEffect } from 'react';

/**
 * Keeps a ref in sync with the latest value.
 * Useful for avoiding stale closures inside event handlers or when needing functionality that spans component state and live DOM elements/logic.
 *
 * @param {*} value - Any state or prop to mirror.
 * @returns {object} - A ref object pointing to the latest value.
 */

export function useSyncedRef(value) {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
